module.exports = __webpack_public_path__ + "img/computer.6d482ef9.png";